<script>
export default {
  data() {
    return {};
  },
  components: {},
  mounted() {
    this.Logout();
  },
  methods: {
    async Logout() {
        window.localStorage.removeItem("userid");
        window.localStorage.removeItem("role");
        window.localStorage.removeItem("token");
        this.$apiService.setAuthToken("");
        this.$router.push("/Login");
    },
  },
};
</script>
